import React from 'react';
import './PoweredByBar.css';

const PoweredByBar = () => {
  return (
    <div className="powered-by-bar">
      <div className="powered-by-content">
        <span className="powered-by-text">Powered by</span>
        <div className="logo-container">
          <img 
            src="/logos/digifarm_logo.png" 
            alt="Digifarm" 
            className="partner-logo"
          />
          <img 
            src="/logos/sentinel2_logo.png" 
            alt="Sentinel-2" 
            className="partner-logo"
          />
          <img 
            src="/logos/esa_logo.png" 
            alt="ESA" 
            className="partner-logo"
          />
        </div>
      </div>
    </div>
  );
};

export default PoweredByBar;